<template>
  <div style="display: flex;justify-content: center;font-size: 14px;color: #606266;">
    <el-form ref="form" :model="form" label-width="220px">
      <el-form-item label="头像">
        <el-upload class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false"
                   :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="form.avatar" :src="imgUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="昵称">
        <el-input v-model="form.nickname"></el-input>
      </el-form-item>
      <el-form-item label="账号绑定手机号" v-show="form.loginType ===3">
        <el-input v-model="form.phone" disabled></el-input><el-button size="mini" @click="showModify">换绑</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
    <ModifyPhone :isLogin="isLogin" @quxiao="quxiao" @shuaxin="init" ></ModifyPhone>
  </div>
</template>

<script>
import {detail, editUser} from "@/api/userApi"
import ModifyPhone from "@/components/ModifyPhone.vue";
import {
  getToken
} from '@/utils/auth'

export default {
  name: "MyProfile",
  components: {ModifyPhone},
  data() {
    return {
      action: this.$target + "/common/upload",
      headers: {
        "Custom-Authorization": "Bearer " + getToken()
      },
      imgUrl: '',
      isLogin: false,
      form: {
        nickname: '',
        avatar: '',
        phone: '',
        loginType: ''
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      detail().then((res) => {
        this.form = res.data
        if (res.data.avatar) {
          this.imgUrl = (res.data.avatar.indexOf('http') >= 0 ? '' : this.$target) + res.data.avatar
        }
      })
    },
    onSubmit() {
      editUser(this.form).then(() => {
        this.$message.success('修改成功')
      })
    },
    showModify(){
      this.isLogin = true
      console.log("////////")
    },
    handleAvatarSuccess(res) {
      this.form.avatar = res.fileName
      this.imgUrl = (res.fileName.indexOf('http') >= 0 ? '' : this.$target) + res.fileName
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }
    },
    quxiao(){
      this.isLogin = false
    }
  },
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>